import $ from 'jquery';
import { formats, locales } from '@lts-web/components/Calendar/config';
import {
    roundMinutes,
    formatDate,
    addDateEvent,
    getDateEvent,
    getDateEventByName,
    addCalendarLink,
    getCalendarData,
    createDateEventList,
    getDateEventList,
    removeDateEventList,
    createCalendarList,
    getCalendarList,
    removeCalendarList
} from '@lts-web/utils/DatesUtil';

const jQuery = $;

$.DatesUtil = {
    formats,
    locales,
    roundMinutes,
    formatDate,
    addDateEvent,
    getDateEvent,
    getDateEventByName,
    addCalendarLink,
    getCalendarData,
    createDateEventList,
    getDateEventList,
    removeDateEventList,
    createCalendarList,
    getCalendarList,
    removeCalendarList,
    numToMonth (month) {
        month = Math.abs(parseInt(month));
        return (month >= 12) ? month-12 : month;
    },
    getMonthArray (min, max, formatFn) {
        formatFn = typeof formatFn === 'function' ? formatFn : function(i){ return i; };

        return Array.apply(0, Array(max || 12)).map(function(_, i){
            return formatFn($.DatesUtil.numToMonth(min + i));
        });
    },
    getYearsArray (min, max, formatFn) {
        formatFn = typeof formatFn === 'function' ? formatFn : function(i){ return i; };

        return Array.apply(0, Array(max || 2)).map(function(_, i){
            return formatFn(min + i);
        });
    },
    setJQueryCalendarDate (valueName, date, formatFrom) {
        if (date) {
            var formatTo = $.DatesUtil.formats.get('default');
            formatFrom = formatFrom || $.DatesUtil.formats.get('deprecated');
            if (window.hasOwnProperty('incrementMonth')) {
                date = incrementMonth(date, false);
            }
            date = $.DatesUtil.formatDate(date, formatTo, formatFrom);
        }

        $.SyncFormUtil($.ModuleUtil.getCurrentModuleName()).setValue(valueName, date);
    },
    setStartDate (date, formatFrom) {
        window.startDate = date;
        $.DatesUtil.setJQueryCalendarDate('departDate', date, formatFrom);
    },
    setEndDate (date, formatFrom) {
        window.endDate = date;
        $.DatesUtil.setJQueryCalendarDate('returnDate', date);
    },
    setDates (startDate, returnDate) {
        $.DatesUtil.setStartDate(startDate);
        $.DatesUtil.setEndDate(returnDate);
    },
    isActiveEvent (element) {
        return $(element).find("input:checked").length > 0;
    },
    goToFirstEvent (element) {
        updateRadioData(checkElement( $(element).closest(".radiogroup").find(".pickDateOptionInput").first()));
        $.SyncEngineUtil.syncAllEngineTextData();
    },
    convertToValidSearchFormat (dateString) {
        if (!$.DatesUtil.isValidDate(dateString))
            return '';

        return dateString.replaceAll('-', '/');
    },
    convertToValidDateStr (dateString) {
        return dateString.split("-").reverse().join("-");
    },
    convertToDefaultFormat (dateString) {
        return (dateString || '').replaceAll('/', '-');
    },
    parseDate (dateString, splitter) {
        if (typeof dateString !== 'string')
            return null;

        var dateArr = dateString.split(splitter || "-");
        return new Date(dateArr[0], parseInt(dateArr[1])-1, dateArr[2]);
    },
    isValidDate (date, splitter) {
        var isValidDate = false;

        try {
            isValidDate = !isNaN($.DatesUtil.parseDate(date, splitter));
        } catch (e) {
            isValidDate = false;
        }

        return date && isValidDate;
    },
    getCurrMonth () {
        return (new Date()).getMonth();
    },
    getCurrYear () {
        return (new Date()).getFullYear();
    },
    isLastDayInMonth (date, maxDays) {
        date     = $.DatesUtil.parseDate(date);
        maxDays  = maxDays || 1;

        var d = date.getDate(),
            m = date.getMonth(),
            y = date.getFullYear(),
            lastDay = new Date(y, m + 1, 0);

        return (d > lastDay.getDate() - maxDays);
    },
    hasActiveDatesNextMonth (dateStr) {
        var nextMonth,
            lastDate,
            actives = activeDates || [],
            len = actives.length,
            date = new Date(dateStr),
            currMonth = date.getMonth();

        if (len <= 0)
            return false;

        lastDate = $.DatesUtil.parseDate(activeDates[len-1]);
        nextMonth = lastDate.getMonth();

        return currMonth+1 == nextMonth;
    },
    isSecondSlide (date) {
        return $('#end-date').find('[data-date="' + date + '"]').length > 0;
    },
    isStartDateSelected () {
        return startDate && startDate !== '0';
    },
    isEndDateSelected () {
        return endDate && endDate !== '0';
    },
    isDatesSelected () {
        return ($.SyncEngineUtil.isOneWay() && $.DatesUtil.isStartDateSelected()) ||  ($.DatesUtil.isStartDateSelected() && $.DatesUtil.isEndDateSelected());
    },
    isSearchResultPage () {
        return  $(".aside-new-search").size() > 0;
    },
    isCalendarColoring () {
        var cityCode = jQuery("." + whereToGo).find(".destElementClz").val();


        return  isAbroadModule();
    },
    isMatrixSearch () {
        return  jQuery(".matrixSearch")[0].checked;
    },
    isFromAbroadSearch () {
        return  $(".fromAbroadSearch").val()=="true";
    },
    specialEventsState (show){
        if(show) {
            EngineUtil.getCurrDateEventsWrapper().find(".radiogroup").addClass("disabledDestination");
        } else {
            EngineUtil.getCurrDateEventsWrapper().find(".radiogroup").removeClass("disabledDestination");
        }
    },
    isCalendarDatesRequired () {
        return $.LocationUtil.isGDSLocation() || $.SyncEngineUtil.isFlexChecked() ||
            $.SyncEngineUtil.isFromAbroadChecked() || $.ModuleUtil().isDomesticModule()
    },

    parseDatesResponse (data) {
        var lines 		= data.split(";"),
            jsonStrAr1 	= (lines[0] || '').replace('ar1', '').replace('=', '').trim(),
            jsonStrAr2 	= (lines[1] || '').replace('ar2', '').replace('=', '').trim(),
            jsonStr2OW 	= (lines[2] || '').replace('CALENDAR_ALLOW_COMBINED_SEARCH', '').replace('=', '').trim();

        if (jsonStrAr1 == '')
            jsonStrAr1 = '[]';

        if (jsonStrAr2 == '')
            jsonStrAr2 = '[]';

        window.is2OW = jsonStr2OW === "true";

        return {
            single: JSON.parse(jsonStrAr1),
            pairs: JSON.parse(jsonStrAr2)
        };
    }
};
